import { Container, Row, Col } from "react-bootstrap";
import {
  MDBCard,
  MDBCardBody,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,
} from "mdb-react-ui-kit";
import video_img from "../assets/img/video_img.png";
import "react-multi-carousel/lib/styles.css";
import TrackVisibility from "react-on-screen";

import level1Img from "../assets/img/lvl1.svg";

export const Levels = () => {
  const level1 = [
    {
      level: "Elections courses",
      description:
        "A selection of courses developed for various elections committees",
      video_url: "https://www.youtube.com/embed/UAKuCQSHmsA",
    },
  ];
  const level2 = [
    {
      level: "Elections courses",
      description:
        "A selection of courses developed for various elections committees",
      video_url: "https://www.youtube.com/embed/UAKuCQSHmsA",
    },
  ];
  const level3 = [
    {
      level: "Elections courses",
      description:
        "A selection of courses developed for various elections committees",
      video_url: "https://www.youtube.com/embed/UAKuCQSHmsA",
    },
  ];
  const level4 = [
    {
      level: "Elections courses",
      description:
        "A selection of courses developed for various elections committees",
      video_url: "https://www.youtube.com/embed/UAKuCQSHmsA",
    },
  ];
  return (
    <section className="level">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility partialVisibility once>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible
                      ? "animate__animated animate__fadeInUp"
                      : "animate__animated animate__fadeOut"
                  }
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <h2>4 LEVELS OF COURSE INTERACTION</h2>
                        <div className="level-bx wow zoomIn">
                          <div className="item" id="levels">
                            <img
                              className="animate__animated animate__zoomIn"
                              src={video_img}
                              alt="video_img"
                            />
                          </div>

                          <iframe
                            className="all_levels_iframe mt-5"
                            width="728"
                            height="410"
                            src="https://www.youtube.com/embed/8RSe4G46HdY"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                          ></iframe>
                          <MDBContainer className="py-4">
                            <MDBRow className="text-center d-flex align-items-stretch ">
                              <MDBCol
                                md="6"
                                className="mb-5 mb-md-0 d-flex align-items-stretch "
                              >
                                <MDBCard>
                                  <div className="levels-thumb">
                                    <iframe
                                      width="355"
                                      height="200"
                                      src="https://www.youtube.com/embed/7c_E-7KMDXk"
                                      title="YouTube video player"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                      allowFullScreen
                                    ></iframe>
                                    <div>
                                      <h4>
                                        {" "}
                                        <b>Level 1 Essential</b>
                                      </h4>
                                      <span>
                                        <p>
                                          All the essential elements delivered
                                          in a premium online learning
                                          experience
                                        </p>
                                      </span>
                                    </div>
                                  </div>
                                </MDBCard>
                              </MDBCol>
                              <MDBCol
                                md="6"
                                className="mb-5 mb-md-0 d-flex align-items-stretch"
                              >
                                <MDBCard className="level-card">
                                  <div className="levels-thumb">
                                    <iframe
                                      width="355"
                                      height="200"
                                      src="https://www.youtube.com/embed/UAKuCQSHmsA"
                                      title="YouTube video player"
                                      frameBorder="0"
                                      allowFullScreen
                                    ></iframe>
                                    <h4>
                                      <b>Level 2 Defined</b>
                                    </h4>
                                    <span>
                                      <p>
                                        A robust and defined e-learning
                                        experience that will help your learners
                                        tackle learning with ease
                                      </p>
                                    </span>
                                  </div>
                                </MDBCard>
                              </MDBCol>
                            </MDBRow>
                          </MDBContainer>
                          <MDBContainer>
                            <MDBRow className="text-center d-flex align-items-stretch ">
                              <MDBCol
                                md="6"
                                className="mb-5 mb-md-0 d-flex align-items-stretch"
                              >
                                <MDBCard>
                                  <div className="levels-thumb">
                                    <iframe
                                      width="355"
                                      height="200"
                                      src="https://www.youtube.com/embed/SXkcaIqzR9Y"
                                      title="YouTube video player"
                                      frameBorder="0"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                      allowFullScreen
                                    ></iframe>
                                    <h4>
                                      <b>Level 3 Moderate</b>
                                    </h4>
                                    <span>
                                      <p>
                                        Dip your toes in the world of gamified
                                        and scenario based e-learning experience
                                      </p>
                                    </span>
                                  </div>
                                </MDBCard>
                              </MDBCol>
                              <MDBCol
                                md="6"
                                className="mb-5 mb-md-0 d-flex align-items-stretch"
                              >
                                <MDBCard>
                                  <div className="levels-thumb">
                                    <iframe
                                      width="355"
                                      height="200"
                                      src="https://www.youtube.com/embed/bk5ypZ3-yYA"
                                      title="YouTube video player"
                                      frameBorder="0"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                      allowFullScreen
                                    ></iframe>
                                    <h4>
                                      <b>Level 4 Immersive</b>
                                    </h4>
                                    <span>
                                      <p>
                                        Immerse in the world of award winning
                                        e-learning solution with captivating
                                        scenarios, storytelling and more
                                      </p>
                                    </span>
                                  </div>
                                </MDBCard>
                              </MDBCol>
                            </MDBRow>
                          </MDBContainer>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
